export function clampValue(value: number, min: number, max: number): number {
  if (isNaN(value)) return min;
  return Math.min(max, Math.max(min, value));
}

export function clampHours(value: number, is12h: boolean): number {
  return is12h ? clampValue(value, 1, 12) : clampValue(value, 0, 23);
}

export function clampMinutes(value: number): number {
  return clampValue(value, 0, 59);
}

export function clampSeconds(value: number): number {
  return clampValue(value, 0, 59);
}

export function formatSegment(value: number | undefined | null): string {
  if (value === undefined || value === null) return "";
  return value.toString().padStart(2, "0");
}

export function parseSegmentInput(text: string): number | null {
  const num = parseInt(text, 10);
  return isNaN(num) ? null : num;
}
